export function fetchEnumsFromSchema(schema: any) {
  const meta: any = {}

  for (const field of schema.fields) {
    switch(field.type) {
      case 'enum': {
        meta[field.code] = { choices: {}, controlItems: [] };

        for (const _type of field.meta.choices) {
          meta[field.code].choices[_type.value] = _type.label;
          meta[field.code].controlItems.push({
            id: _type.value,
            label: _type.label
          });
          
        }

        break;
      }
      case 'contacts': {
        meta[field.code] = { types: {} };

        for (const _type of field.meta.types) {
          meta[field.code].types[_type.value] = _type.label;
    
          if(_type.type_extras) {
            for(const extraType of _type.type_extras) {
              meta[field.code].types[_type.value + extraType.value] = `${_type.label} / ${extraType.label}`;
            }
          }
        }
        break;
      }
    }
  }

  return meta;
}